import { ETheme, FluentProvider } from "@/DependenciesV9";
import { RootState } from "@/redux";
import { ILayoutProps } from "@/views/layout/Model.ts";
import Content from "@/views/layout/content";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { PageWrapper } from "./Style.ts";
import Header from "./header";
import { Route, Routes } from "react-router-dom";
import Login from "@/views/login";
import { PublicRoute } from "@/routers/PublictRouter.tsx";
import { PrivateRoute } from "@/routers/PrivateRouter.tsx";

const Layout = (props: ILayoutProps) => {
  const theme: ETheme = useSelector(
    (state: RootState) => state.settingInfo?.theme,
  );

  useEffect(() => {
    setUserRoles();
    setUserInfo();
  }, []);

  const setUserRoles = () => {
    if (props.setUserRoles) {
      props.setUserRoles();
    }
  };

  const setUserInfo = async () => {
    if (props.setUserInfo) {
      await props.setUserInfo();
    }
  };

  return (
    <Routes>
      <Route element={<PublicRoute />}>
        <Route path="/login" element={<Login />} />
      </Route>
      <Route element={<PrivateRoute />}>
        <Route
          path="/*"
          element={
            <PageWrapper className="PageWrapper">
              <Header></Header>
              <FluentProvider theme={theme}>
                <Content />
              </FluentProvider>
            </PageWrapper>
          }
        />
      </Route>
    </Routes>
  );
};

export default Layout;
